export function success(title, message) {
  toastr.success(message, title);
}

export function info(title, message) {
  toastr.info(message, title);
}

export function warning(title, message) {
  toastr.warning(message, title);
}

export function error(title, message) {
  toastr.error(message, title);
}


// WEBPACK FOOTER //
// ./client/app/shared/ui/utils/toastr.js